if (!customElements.get('subscription-form')) {
  customElements.define(
    'subscription-form',
    class SubscriptionForm extends HTMLElement {
      constructor() {
        super();
      }

      page = 1;
      isLoading = false;
      postSubscriptionAction = null;

      connectedCallback() {
        this.setupReferences();
        this.setupPostSubscriptionAction();
        this.setupEventListeners();
        this.checkIfUserIsAlreadySubscribed();
      }

      setupReferences = () => {
        this.campaign = this.getAttribute('campaign');
        this.isMultistep = this.getAttribute('multistep') === 'true';
        this.coupon_code = this.getAttribute('coupon_code');

        this.$inputsWrappers = this.querySelectorAll(
          '[data-selector="inputs-wrapper"] > [data-selector="inputs-wrapper-input"]'
        );
        this.$inputs = this.querySelectorAll(
          '[data-selector="inputs-wrapper"] > [data-selector="inputs-wrapper-input"] input'
        );

        this.$form = this.querySelector('form');

        this.$redirectURLInput = this.querySelector('[name="redirect_url"]');
        this.$redirectURLLink = this.querySelector('.redirect-url-link');

        this.$stepperDots = this.querySelector('stepper-dots');

        this.$buttonNextStep = this.querySelector('.next-step');

        this.$buttonSubmit = this.querySelector('button[type="submit"]');
        this.$submitButtonLoadingIcon = this.$buttonSubmit.querySelector('.loading-icon');
        this.$submitButtonText = this.$buttonSubmit.querySelector('.button-text');

        this.$couponCodeWrapper = this.querySelector('.coupon-code');
        this.$copyCouponCodeButton = this.querySelector('.copy-coupon-code');
        this.$copyCouponCodeButtonIcon = this.querySelector('.copy-coupon-code svg use');

        this.$feedback = this.querySelector('.feedback');
        this.$feedbackSuccess = this.querySelector('.feedback .message.success');
        this.$feedbackError = this.querySelector('.feedback .message.error');
        this.$feedbackErrorMessage = this.querySelector('.feedback .message.error span.message');
      };

      setupPostSubscriptionAction = () => {
        if (this.$redirectURLInput) {
          this.postSubscriptionAction = this.redirect;
        } else if (this.coupon_code) {
          this.postSubscriptionAction = this.displayCoupon;
        } else {
          this.postSubscriptionAction = this.displaySuccess;
        }
      };

      setupEventListeners = () => {
        if (this.isMultistep) {
          this.$buttonNextStep?.addEventListener('click', this.goNextPage);
        }

        this.$form.addEventListener('submit', this.onSubmit);
        this.$copyCouponCodeButton?.addEventListener('click', this.copyCouponCode);

        this.$inputs.forEach(($input) => {
          $input.addEventListener('focus', this.hideFeebacks);
        });
      };

      hideFeebacks = () => {
        this.$feedback.classList.add('tw-hidden');
      };

      validateCurrentInput = ($input) => {
        let isValid = true;

        const isEmpty = !$input.value;
        const isRequired = $input.required;

        if (isEmpty && !isRequired) {
          isValid = true;
          return isValid;
        }

        $input.setCustomValidity('');

        const inputValidationMap = {
          email: window.RegexValidation?.isEmailValid,
          phone: window.RegexValidation?.isPhoneValid,
        };

        function capitalize(str) {
          if (!str) return str; // Handle empty string
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }

        const inputValidationFunction = inputValidationMap[$input.name] || $input.checkValidty;

        if (!inputValidationFunction) {
          isValid = true;
          return isValid;
        }

        isValid = inputValidationFunction($input.value);

        if (!isValid) {
          //triggers browser input validation api
          $input.focus();
          $input.setCustomValidity(`${capitalize($input.name)} is invalid`);
          $input.reportValidity();
        }

        return isValid;
      };

      onSubmit = async (e) => {
        e.preventDefault();

        if (this.isLoading) return;

        const $currentPageInput = this.$inputsWrappers[this.page - 1]?.querySelector('input');

        const isValid = this.validateCurrentInput($currentPageInput);
        if (!isValid) return;

        this.setLoading(true);
        this.dispatchSubscriptionEvent();
        const subcriptionResult = await this.subscribe();
        const [error, response] = subcriptionResult;
        if (error) {
          this.setLoading(false);
          return this.displayError(error);
        }
        this.postSubscriptionAction(response);
      };

      copyCouponCode = (e) => {
        navigator.clipboard.writeText(e.currentTarget.value);
        this.$copyCouponCodeButtonIcon.setAttribute('href', '#icon:copy-filled');
      };

      dispatchSubscriptionEvent = () => {
        const { subscriptionFormSubscribed } = window.FarmRio.events;
        const event = new CustomEvent(subscriptionFormSubscribed, {
          detail: {
            campaign: this.campaign,
          },
        });
        document.dispatchEvent(event);
      };

      setLoading = (isLoading) => {
        this.isLoading = isLoading;
        if (isLoading) {
          this.$submitButtonLoadingIcon.classList.remove('tw-hidden');
          this.$submitButtonText.classList.add('tw-hidden');
        } else {
          this.$submitButtonLoadingIcon.classList.add('tw-hidden');
          this.$submitButtonText.classList.remove('tw-hidden');
        }
      };

      subscribe = () => {
        try {
          if (!Backend) return [new Error(`Backend Service is ${typeof Backend}`), null];
          const formData = new FormData(this.$form);
          const body = {
            customer: {
              firstName: formData.get('firstName'),
              lastName: formData.get('lastName'),
              birthdate: formData.get('birthdate'),
              email: formData.get('email'),
              phone: formData.get('phone'),
              tags: formData.has('tags')
                ? formData
                    .get('tags')
                    .split(',')
                    .map((tag) => tag.trim())
                : [],
            },
            klaviyo: {
              listId: formData.get('klaviyo_list_id'),
            },
            redirectURL: formData.has('redirect_url') ? formData.get('redirect_url') : null,
          };
          return Backend.subscribe(body);
        } catch (e) {
          return [e, null];
        }
      };

      redirect = (response) => {
        window.location.href = response.redirectURL;
      };

      displayCoupon = () => {
        this.$form.classList.add('tw-hidden');
        this.$feedback.classList.remove('tw-hidden');
        this.$feedbackSuccess.classList.remove('tw-hidden');
        this.$couponCodeWrapper.classList.remove('tw-hidden');
      };

      displayError = (e) => {
        if (e.status >= 400 && e.status < 500) {
          this.$feedbackErrorMessage.innerText = e.message;
          this.page = 0;
          this.goNextPage();
        } else {
          this.$form.classList.add('tw-hidden');
        }
        this.$feedback.classList.remove('tw-hidden');
        this.$feedbackError.classList.remove('tw-hidden');
      };

      displaySuccess = () => {
        this.$form.classList.add('tw-hidden');
        this.$feedback.classList.remove('tw-hidden');
        this.$feedbackSuccess.classList.remove('tw-hidden');
      };

      isLastPage = () => this.page === this.$inputsWrappers.length;

      goNextPage = () => {
        this.hideFeebacks();
        const $currentPageInput = this.$inputsWrappers[this.page - 1]?.querySelector('input');
        const isValid = $currentPageInput ? this.validateCurrentInput($currentPageInput) : true;
        if (!isValid) return;

        this.page++;
        this.$stepperDots.page = Number(this.$stepperDots.page) + 1;

        this.$inputsWrappers.forEach(($inputWrapper) => {
          $inputWrapper.style.transform = `translateX(-${(this.page - 1) * 100}%)`;
        });

        if (this.isLastPage()) {
          this.$buttonNextStep.classList.add('tw-hidden');
          this.$buttonSubmit.classList.remove('tw-hidden');
        } else {
          this.$buttonNextStep.classList.remove('tw-hidden');
          this.$buttonSubmit.classList.add('tw-hidden');
        }
      };

      checkIfUserIsAlreadySubscribed = () => {
        if (!this.$redirectURLLink) return;
        const formData = new FormData(this.$form);
        if (!formData.has('tags')) return;
        const tags = formData
          .get('tags')
          .split(',')
          .map((tag) => tag.trim());
        const customer = window.Customer.data;
        if (!customer.tags) return;
        const customerIsSubscribed = tags.every((tag) => customer.tags.includes(tag));
        if (customerIsSubscribed) {
          this.$form.classList.add('tw-hidden');
          this.$feedback.classList.remove('tw-hidden');
          this.$redirectURLLink.classList.remove('tw-hidden');
          this.$redirectURLLink.classList.add('tw-flex');
        }
      };
    }
  );
}
